//api接口统一出口

// //正式
import home from './modules/home.api'
// import rewrite from './modules/rewrite.api'
//开发
// import home from './modules/home.api'
//home和测试发布
// import home from './modules/home_home.api'


//导出
export default {
    home
}


// WEBPACK FOOTER //
// ./src/api/index.js